import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'footer-html',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})

export class FooterComponent implements OnInit {
  constructor() { }
  ngOnInit() {}
}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/footer/footer.component.ts